import { styled } from '@mui/material/styles';
import { SharedProgressStyles } from '../../mui/components/layouts/headers/SimpleHeaders/sharedStyles';

export const Wrapper = styled('div')(
  ({ theme, progress }) => `


    ${SharedProgressStyles({ theme, progress })}

`,
);
